import {
  Directive,
  ElementRef,
  Output,
  EventEmitter,
  Input,
  Renderer2,
  OnChanges,
  OnInit,
  OnDestroy,
} from '@angular/core';

@Directive({
  selector: '[infiniteScroll]',
})
export class InfiniteScrollDirective implements OnChanges, OnInit, OnDestroy {
  @Input() scrollOffset: number = 1;
  @Input() active: boolean = true;
  @Input() isMobile: boolean;
  @Output() scrolled = new EventEmitter<void>();

  private scrollListener: () => void;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.updateScrollListener();
  }

  ngOnChanges(): void {
    this.updateScrollListener();
  }

  private updateScrollListener(): void {
    if (this.active && !this.scrollListener) {
      this.scrollListener = this.renderer.listen(
        this.el.nativeElement,
        this.isMobile ? 'touchmove' : 'scroll',
        (event) => {
          this.createListener(event);
        },
      );
    } else if (this.scrollListener && !this.active) {
      this.scrollListener(); // Detach the listener
      this.scrollListener = null;
    }
  }

  createListener(event) {
    const target = event.target;
    const scrollPosition = target.scrollTop + target.clientHeight;
    const scrollHeight = target.scrollHeight;

    if (scrollPosition >= scrollHeight - this.scrollOffset) {
      this.scrolled.emit();
    }
  }

  ngOnDestroy(): void {
    if (this.scrollListener) {
      this.scrollListener();
    }
  }
}
